module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "padding": "1rem 1rem 1rem 1rem",
      "border": "1px solid whitesmoke",
      "border-radius": "10px"
    }
  }, [_c('form', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Organization name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.companyName),
      expression: "client.companyName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.client.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "companyName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Organization logo")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-primary has-name is-fullwidth is-right"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "name": "logo",
      "id": "logo"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange()
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "file-name",
    staticStyle: {
      "background": "#fff",
      "max-width": "6em !important"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.pictureName ? _vm.pictureName : 'Client Logo') + "\n                    ")])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Minimum size: width 200px * height 40px")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Team name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.teamName),
      expression: "initiative.teamName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.initiative.teamName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "teamName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider",
    staticStyle: {
      "background-color": "lightgrey"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Initiative name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.name),
      expression: "initiative.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.initiative.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Assessment due date")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon deadlineInput"
  }, [_c('datetime', {
    attrs: {
      "min-datetime": new Date().toISOString(),
      "max-datetime": new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString(),
      "use12-hour": true,
      "type": "datetime",
      "minute-step": 15,
      "auto": true,
      "format": {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      },
      "placeholder": _vm.initiative.deadline
    },
    model: {
      value: (_vm.initiative.deadline),
      callback: function($$v) {
        _vm.$set(_vm.initiative, "deadline", $$v)
      },
      expression: "initiative.deadline"
    }
  }), _vm._v(" "), _vm._m(3)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Initiative description")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initiative.initiativeDetails),
      expression: "initiative.initiativeDetails"
    }],
    staticClass: "textarea",
    attrs: {
      "rows": "3",
      "placeholder": "Enter initiative description"
    },
    domProps: {
      "value": (_vm.initiative.initiativeDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.initiative, "initiativeDetails", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadData()
      }
    }
  }, [_vm._v("Reset")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n        Manage Assessment\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n        Welcome to the Assessment management page. Here you can add or modify Assessment information.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-cta"
  }, [_c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v("\n                        upload logo\n                      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19967256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/assessment/assessmentInfo.vue
// module id = 360
// module chunks = 5